<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-05 17:09:07
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-07 17:30:18
 * @FilePath: \member_ship\src\views\details.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="delBody">
    <div class="headerBox">
      <div class="backBtnBox" @click="backpage">
        <i class="el-icon-arrow-left"></i>
      </div>供需详情
    </div>
    <div class="mainBXoy">
      <div class="titleBox">{{arrData.Title}}</div>
      <div class="listuserInfoBox">
        <div class="leftBox">
          <p>{{arrData.Username}}</p>
          <p style=" font-size: 12px;color:#a3a3a3">{{arrData.Hangye}}</p>
        </div>
        <div>{{getTime(arrData.CreateTime)}}</div>
      </div>
      <div class="maintextBox">
       {{arrData.Content}}
      </div>
      

    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      macPhoto: "",
      message: "",
      title: "",
      type: "供应",
      showPicker2: false,
      tabList: ["供应", "求购", "合作", "出租", "求租"],
      arrData:{
        CreateTime:"1754555121000"
      },
    };
  },
  mounted(){
    console.log(this.$route.query);
    this.arrData = this.$route.query
  },
  created(){
// this.arrData = this.$route.query
  },
  methods: {
    getTime(time){
      console.log(time/1000);
      console.log();
      return moment(Number(time)).format("YYYY-MM-DD HH:mm:ss")
    },
    backpage() {
      this.$router.back();
    },
    fileDataChange2(e) {
      console.log(e);
      this.macPhoto = `https://www.moodsci.com${e}`;
    },
    openMybox() {
      this.showPicker2 = true;
    },
    popColose() {}
  }
};
</script>

<style>
.delBody {
  height: 100vh;
  width: 100vw;
}
.headerBox {
  height: 50px;
  text-align: center;
  line-height: 50px;
  line-height: 50px;
}
.backBtnBox {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 10px;
  font-size: 30px;
  /* top: 10px; */
}
.mainBXoy {
  width: 100%;
  height: calc(100vh - 50px);
  padding: 0 20px;
}
.listuserInfoBox {
  width: 100%;
  height: 30px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leftBox {
  width: 50%;
  height: 100%;
  /* background-color: aqua; */
}
.maintextBox {
  /* height: 100px; */
  width: 100%;
  margin-top: 15px;
}
.maintextBox p{
    margin-top: 15px;
}
</style>